import React, { useState } from "react";
import Swal from "sweetalert2";
import { DialogActions } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import { FormArrayTextField } from "../../../../partials/content/Forms/FormField";
import { Table } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchVariant from "../../inventory/items/searchVariant";
import SearchItemUom from "../../inventory/items/searchItemUom";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function ItemUnitsPriceFormContent({ customerGroupID = 0, onCloseDialog }) {
  const { values, handleSubmit, setFieldValue } = useFormikContext();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openSearchVariant, setOpenSearchVariant] = useState(false);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  return (
    <React.Fragment>
      <FieldArray name="itemUnitsPrice">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.itemUnitsPrice &&
                    values.itemUnitsPrice.length > 0 ? (
                      <thead className="text-center">
                        <th style={{ width: "50%" }}>Variant</th>
                        <th style={{ width: "20%" }}>Unit</th>
                        <th style={{ width: "25%" }}>Selling Price</th>
                        <th>Actions</th>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.itemUnitsPrice &&
                      values.itemUnitsPrice.length > 0 ? (
                        values.itemUnitsPrice.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemUnitsPrice"
                                  index={index}
                                  propName="itemName"
                                  margin="none"
                                  value={item.itemName}
                                  searchButton
                                  clearButton
                                  readonly
                                  onSearchClick={() => {
                                    setSelectedIndex(index);
                                    setOpenSearchVariant(true);
                                  }}
                                  onClearFields={() => {
                                    setFieldValue(
                                      `itemUnitsPrice[${index}].itemName`,
                                      "No Variant"
                                    );
                                    setFieldValue(
                                      `itemUnitsPrice[${index}].varCode`,
                                      ""
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemUnitsPrice"
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  value={item.uomName}
                                  searchButton
                                  readonly
                                  onSearchClick={() => {
                                    setSelectedIndex(index);
                                    setOpenSearchUom(true);
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemUnitsPrice"
                                  index={index}
                                  propName="price"
                                  margin="none"
                                  currencyField
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                <BootstrapTooltip
                                  title={
                                    item.deleteInd
                                      ? "Undo Delete"
                                      : "Delete Alternative Variant Unit Price Item"
                                  }
                                >
                                  <button
                                    type="button"
                                    className={`btn btn-icon btn-label-${
                                      item.deleteInd ? "warning" : "danger"
                                    } btn-md btn-circle mx-1`}
                                    onClick={() => {
                                      if (item.ID > 0) {
                                        const itemUnitsPriceTmp = [
                                          ...values.itemUnitsPrice,
                                        ];
                                        itemUnitsPriceTmp[
                                          index
                                        ].deleteInd = !item.deleteInd;
                                        setFieldValue(
                                          "itemUnitsPrice",
                                          itemUnitsPriceTmp
                                        );
                                      } else {
                                        remove(index);
                                      }
                                    }}
                                  >
                                    {item.deleteInd ? (
                                      <i className="fas fa-undo-alt"></i>
                                    ) : (
                                      <i className="fas fa-trash-alt"></i>
                                    )}
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="4">
                            <Illustration
                              imageSource="INVIFO Sales.png"
                              guidance="You don't have any Alternative Variant Unit Prices for this item
                          yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="text-center py-3" colSpan="4">
                          <button
                            type="button"
                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                            onClick={() => {
                              push({
                                customerGroupID,
                                itemID: values.item.ID,
                                itemCode: values.item.itemCode,
                                varCode: "",
                                itemName: "No Variant",
                                uomID: 0,
                                uomName: "",
                                price: 0,
                                deleteInd: false,
                              });
                            }}
                          >
                            <i className="fas fa-plus-circle"></i>
                            Add Alternative Variant Unit Price
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchVariant}
        title={`Search Variant`}
        onCloseDialog={() => {
          setOpenSearchVariant(false);
        }}
        maxWIdth="sm"
      >
        <SearchVariant
          itemID={values.item.ID}
          onSelectVariant={(varCode, valueName) => {
            setFieldValue(`itemUnitsPrice[${selectedIndex}].varCode`, varCode);
            setFieldValue(
              `itemUnitsPrice[${selectedIndex}].itemName`,
              valueName
            );
            setOpenSearchVariant(false);
          }}
          onCloseDialog={() => {
            setOpenSearchVariant(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="sm"
      >
        <SearchItemUom
          itemID={values.item.ID}
          onSelectUom={(uom) => {
            if (
              values.itemUnitsPrice[selectedIndex].varCode === "" &&
              uom.ID === values.item.uomID
            ) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text:
                  "Unable to select item Base Unit with No Variant combination. Please pick any Variant first before select item Base Unit",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            } else {
              setFieldValue(`itemUnitsPrice[${selectedIndex}].uomID`, uom.ID);
              setFieldValue(
                `itemUnitsPrice[${selectedIndex}].uomName`,
                uom.uomName
              );
            }
            setOpenSearchUom(false);
          }}
          onCloseDialog={() => {
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        {values.itemUnitsPrice && values.itemUnitsPrice.length > 0 ? (
          <button
            type="submit"
            className="btn btn-success btn-md btn-pill btn-bold"
            onSubmit={handleSubmit}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        ) : null}
      </DialogActions>
    </React.Fragment>
  );
}

export default ItemUnitsPriceFormContent;
